/*
 * Copyright (c) 2021 JCA Electronics , Winnipeg, MB. All rights reserved.
 */
enum MissionTabNames {
  InProgressMissions = 'In Progress',
  CompletedMissions = 'Completed',
  AddAndEditMissions = 'Add & Edit'
}

export default MissionTabNames;
